import { OpenPanel } from "@openpanel/web";

export const op = new OpenPanel({
	clientId: process.env.BUN_PUBLIC_OPENPANEL_CLIENT_ID,
	apiUrl: process.env.BUN_PUBLIC_OPENPANEL_API_URL,
	trackScreenViews: true,
	trackOutgoingLinks: true,
	trackAttributes: true,
	trackHashChanges: true,
});
